(function() {
    'use strict';
    angular
        .module('backmann', [
            'ngAnimate', 
            'ngCookies', 
            'ngSanitize', 
            'ngMessages', 
            'ngAria', 
            'ngResource', 
            'ui.router', 
            'ngMaterial', 
            'toastr', 
            'ui.materialize', 
            'ngFlowGrid',
            'angular.vertilize'
        ]);

})();

(function() {
  'use strict';

  angular
      .module('backmann')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Angular Material Design',
        'url': 'https://material.angularjs.org/#/',
        'description': 'The Angular reference implementation of the Google\'s Material Design specification.',
        'logo': 'angular-material.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('backmann')
    .directive('acmeNavbar', acmeNavbar)
    .directive('scrollNav', scrollNav);
    

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

  function scrollNav($window){
    return function(scope){
      angular.element($window).bind("scroll", function(){
        if(this.pageYOffset >= 50) {
          scope.scrollDown = true;
        }else{
          scope.scrollDown = false;
        }
        scope.$apply();
      });
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('backmann')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('backmann')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('backmann')
    .controller('ContactFormController', contactForm);

  /** @ngInject */
  contactForm.$inject = ['$http', '$log'];
  function contactForm($http, $log) {
    var vm = this;
    vm.success = false;
    vm.error = false;
    vm.formData = {};
    vm.responseData = {};

    vm.sendMail = function(){
      $log.log("Sending mail", vm.formData);
      $http({
        url: 'scripts/contactForm.php',
        method: 'POST',
        headers: {'Content-Type':'x-www-form-urlencoded'},
        data: vm.formData
      }).success(function(data){
        $log.log(data, vm);
        vm.responseData = data;
        vm.formData = {};
      }, function(error){
        $log.log(error);
      });
    };
  }
})();

/*!
  * angular-vertilize 1.0.1
  * Christopher Collins
  * https://github.com/Sixthdim/angular-vertilize.git
  * License: MIT
*/
(function () {
  "use strict";

angular.module('angular.vertilize', [])

// Vertilize Container
.directive('vertilizeContainer', vertilizeContainer)
.directive('vertilize', vertilize);

function vertilizeContainer(){
    return {
      restrict: 'EA',
      controller: [
        '$scope', '$window',
        function($scope, $window){
          // Alias this
          var _this = this;

          // Array of children heights
          _this.childrenHeights = [];

          // API: Allocate child, return index for tracking.
          _this.allocateMe = function(){
            _this.childrenHeights.push(0);
            return (_this.childrenHeights.length - 1);
          };

          // API: Update a child's height
          _this.updateMyHeight = function(index, height){
            _this.childrenHeights[index] = height;
          };

          // API: Get tallest height
          _this.getTallestHeight = function(){
            var height = 0;
            for (var i=0; i < _this.childrenHeights.length; i=i+1){
              height = Math.max(height, _this.childrenHeights[i]);
            }
            return height;
          };

          // Add window resize to digest cycle
          angular.element($window).bind('resize', function(){
            return $scope.$apply();
          });
        }
      ]
    };
}

function vertilize(){
  return {
        restrict: 'EA',
        require: '^vertilizeContainer',
        link: function(scope, element, attrs, parent){
          // My index allocation
          var myIndex = parent.allocateMe();

          // Get my real height by cloning so my height is not affected.
          var getMyRealHeight = function(){
            var clone = element.clone()
              .removeAttr('vertilize')
              .css({
                height: '',
                width: element.outerWidth(),
                position: 'fixed',
                top: 0,
                left: 0,
                visibility: 'hidden'
              });
            element.after(clone);
            var realHeight = clone.height();
            clone['remove']();
            return realHeight;
          };

          // Watch my height
          scope.$watch(getMyRealHeight, function(myNewHeight){
            if (myNewHeight){
              parent.updateMyHeight(myIndex, myNewHeight);
            }
          });

          // Watch for tallest height change
          scope.$watch(parent.getTallestHeight, function(tallestHeight){
            if (tallestHeight){
              element.css('height', tallestHeight);
            }
          });
        }
      };
    }

}());
(function() {
  'use strict'; 

  angular
    .module('backmann')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1461693148325;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function(){
	'use strict';
	angular
		.module('backmann')
		.controller('GalleryController', GalleryController);
		GalleryController.$inject = ['$log', '$http', 'fgDelegate', '$scope'];

	function GalleryController($log, $http, fgDelegate, $scope){
		var vm = this;
		vm.success = false;
		vm.error = false;
		vm.photoset = [];
		vm.thumbset = [];

		var user2 = '108289398827068840242';
		var album2 = '6286140737057923649';
		var albumUrl = "http://picasaweb.google.com/data/feed/base/user/" + user2 + "/albumid/" + album2 + "?v=2&alt=json";
		var flow = {};

		$http.get(albumUrl).then(function(res){
			var entries = res.data.feed.entry;
			for (var i = 0; i < entries.length; i++) {
				vm.thumbset[i] = entries[i].media$group.media$thumbnail[2].url;
				vm.photoset[i] = entries[i].media$group.media$thumbnail[2].url.replace('s288', 's0');
			}
			flow = fgDelegate.getFlow('galleryGrid');
			$scope.$watch($scope.$last, function(){
				$log.log('loading finished', flow);
				flow.itemsChanged();
			});
		});

		
	}
})();
(function(){
	'use strict';
	angular
		.module('backmann')
		.controller('EmpleoController', EmpleoController);
		EmpleoController.$inject = ['$log', '$http'];

	function EmpleoController($log, $http){
		var vm = this;
		vm.success = false;
		vm.error = false;
    vm.formData = {};
    vm.responseData = {};

    vm.sendMail = function() {
      $log.log("Sending mail", vm.formData);
      $http({
        url: 'scripts/empleoForm.php',
        method: 'POST',
        headers: {'Content-Type': 'x-www-form-urlencoded'},
        data: vm.formData
      }).success(function (data) {
        $log.log(data, vm);
        vm.responseData = data;
        vm.formData = {};
      });
    };
		vm.status = ["Soltero", "Casado"];
		vm.scholar = ["Primaria", "Secundaria", "Preparatoria", "Técnica", "Profesional"];

		vm.Range = function(start, end) {
			var result = [];
			for (var i = start; i <= end; i++) {
				result.push(i);
			}
			return result;
		};
	}
})();

(function() {
  'use strict';

  angular
    .module('backmann')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $anchorScroll) {
    $log.debug('runBlock end');
    $anchorScroll.yOffset = 50;
  }

})();

(function() {
  'use strict';

  angular
    .module('backmann')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .state('empleos', {
        url:'/empleos',
        templateUrl: 'app/empleo/empleo.html',
        controller: 'EmpleoController',
        controllerAs: 'vm'
      })
      .state('gallery', {
        url: '/gallery', 
        templateUrl: 'app/gallery/gallery.html',
        controller: 'GalleryController', 
        controllerAs: 'vm'
      });

    $urlRouterProvider.otherwise('/');
  }
})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('backmann')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('backmann')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

})();

angular.module("backmann").run(["$templateCache", function($templateCache) {$templateCache.put("app/empleo/empleo.html","<section class=jumbotron><div class=\"row container\"><div class=\"col s12\"><div class=\"quienes-header z-depth-1\"><div class=header-quote><h4 class=\"italic bold left-align\">Oportunidad de Empleo</h4></div></div></div></div></section><section><div class=\"row container\"><div class=\"col s12\" ng-controller=\"EmpleoController as ec\"><form name=form role=form novalidate><h4 class=\"italic underline\">Solicitud de Empleo</h4><p ng-show=ec.success>Gracias por contactarnos</p><p ng-show=ec.error>Algo sucedió con los datos que nos envias, intenta de nuevo</p><p>Envianos tus datos y comentarios, estaremos en contacto a la brevedad.</p><div class=row><div class=\"col s12\"><h6 class=grey-text>Información Personal:</h6><div class=\"input-field col s12 l8\"><input type=text id=name class=validate name=name ng-model=ec.formData.name required><label for=name>Nombre:</label></div><div class=\"input-field col s12 offset-l2 l2\"><select id=edad name=edad ng-model=ec.formData.edad material-select><option ng-repeat=\"age in ec.Range(18,80)\">{{age}}</option></select><label for=edad>Edad:</label></div><div class=\"input-field col s12 l8\"><input type=text id=address class=validate name=address ng-model=ec.formData.address required><label for=address>Dirección:</label></div><div class=\"input-field col s12 l6\"><input type=email name=email id=email class=validate ng-model=ec.formData.email required><label for=email>Correo:</label></div><div class=\"input-field col s12 l6\"><input type=tel name=telephone id=telephone class=validate ng-model=ec.formData.telephone required><label for=telephone>Teléfono:</label></div><div class=\"input-field col s6\"><select id=status name=status ng-model=ec.formData.status material-select><option ng-repeat=\"status in ec.status\">{{status}}</option></select><label for=status>Estado Civil:</label></div><div class=\"input-field col s6\"><input type=text id=nationality class=validate name=nationality ng-model=ec.formData.nationality required><label for=nationality>Nacionalidad:</label></div><div class=\"input-field col s6\"><select id=scholar name=scholar ng-model=ec.formData.scholar material-select><option ng-repeat=\"scholar in ec.scholar\">{{scholar}}</option></select><label for=scholar>Escolaridad:</label></div><div class=\"input-field col s12\"><input type=text id=position class=validate name=position ng-model=ec.formData.position required><label for=position>Puesto que solicita:</label></div></div></div><div class=row><div class=\"col s12\"><h6 class=grey-text>Experiencia Laboral:</h6><div class=section><div class=\"input-field col s12 l4\"><input type=text id=expertize1 class=validate name=expertize1 ng-model=ec.formData.expertize1 required><label for=expertize1>Empresa:</label></div><div class=\"input-field col s12 l4\"><input type=text id=activity1 class=validate name=activity1 ng-model=ec.formData.activity1 required><label for=activity1>Actividad:</label></div><div class=\"input-field col s12 l4\"><input type=text id=prevsalary1 class=validate name=prevsalary1 ng-model=ec.formData.prevsalary1 required><label for=prevsalary1>Sueldo Estimado:</label></div></div><div class=section><div class=\"input-field col s12 l4\"><input type=text id=expertize2 class=validate name=expertize2 ng-model=ec.formData.expertize2 required><label for=expertize2>Empresa:</label></div><div class=\"input-field col s12 l4\"><input type=text id=activity2 class=validate name=activity2 ng-model=ec.formData.activity2 required><label for=activity2>Actividad:</label></div><div class=\"input-field col s12 l4\"><input type=text id=prevsalary2 class=validate name=prevsalary2 ng-model=ec.formData.prevsalary2 required><label for=prevsalary2>Sueldo Estimado:</label></div></div><div class=section><div class=\"input-field col s12 l4\"><input type=text id=expertize3 class=validate name=expertize3 ng-model=ec.formData.expertize3 required><label for=expertize3>Empresa:</label></div><div class=\"input-field col s12 l4\"><input type=text id=activity3 class=validate name=activity3 ng-model=ec.formData.activity3 required><label for=activity3>Actividad:</label></div><div class=\"input-field col s12 l4\"><input type=text id=prevsalary3 class=validate name=prevsalary3 ng-model=ec.formData.prevsalary3 required><label for=prevsalary3>Sueldo Estimado:</label></div></div></div></div><div class=row><div class=\"col s12\"><h6 class=grey-text>Referencias Personales:</h6><div class=section><div class=\"input-field col s12 l6\"><input type=text id=refname1 class=validate name=refname1 ng-model=ec.formData.refname1 required><label for=refname1>Nombre:</label></div><div class=\"input-field col s12 l6\"><input type=text id=reftel1 class=validate name=reftel1 ng-model=ec.formData.reftel1 required><label for=reftel1>Teléfono:</label></div></div><div class=section><div class=\"input-field col s12 l6\"><input type=text id=refname2 class=validate name=refname2 ng-model=ec.formData.refname2 required><label for=refname2>Nombre:</label></div><div class=\"input-field col s12 l6\"><input type=text id=reftel2 class=validate name=reftel2 ng-model=ec.formData.reftel2 required><label for=reftel2>Teléfono:</label></div></div><div class=section><div class=\"input-field col s12 l6\"><input type=text id=refname3 class=validate name=refname3 ng-model=ec.formData.refname3 required><label for=refname3>Nombre:</label></div><div class=\"input-field col s12 l6\"><input type=text id=reftel3 class=validate name=reftel3 ng-model=ec.formData.reftel3 required><label for=reftel3>Teléfono:</label></div></div></div></div><div><input type=text id=honeypot name=honeypot ng-model=ec.formData.honeypot class=hide></div><div class=\"input-field col s12 right\"><button class=\"btn waves-effect waves-light\" ng-show=ec.formData ng-click=\"form.$valid && ec.sendMail()\">Enviar <i class=\"material-icons right\">send</i></button></div></form><p ng-show=ec.responseData.comments message=ec.responseData.comments toast=click></p></div></div></section>");
$templateCache.put("app/gallery/gallery.html","<section class=jumbotron><div class=\"row container\"><div class=\"col s12\"><div class=\"galeria-header z-depth-1\"><div class=header-quote><h4 class=\"italic bold left-align\">Galería</h4></div></div></div></div></section><section><div class=\"row container\"><ul class=\"flowGrid center\" ng-flow-grid=galleryGrid min-item-width=300><li class=flowGridItem ng-repeat=\"img in vm.photoset\"><a href=\"\" class=z-depth-1><img materialboxed class=\"materialboxed responsive-img\" src=\"\" alt=\"\" ng-src={{img}}></a></li></ul></div></section>");
$templateCache.put("app/main/main.html","<section class=jumbotron><div class=\"row container\"><div class=\"col s12\"><div class=\"quienes-header z-depth-1\"><div class=header-quote><h4 class=\"italic bold left-align\">Calidad</h4><h4 class=\"italic bold center-align\">Atención</h4><h4 class=\"italic bold right-align\">Eficiencia</h4></div></div></div></div></section><section id=par-quienes><div class=\"row container\"><div class=\"col s12\"><h4 class=\"italic underline\">Quienes Somos</h4><p>Estructuras Metálicas Backmann es una empresa dedicada al mercado del acero, desarrollan y proporcionan productos y servicios de la más alta calidad desde hace más de 50 años, por ello sus clientes siguen confiando sus proyectos dada la capacidad, calidad y respuesta oportuna que han demostrado siempre.</p><p>Cuentan con equipos de control digital, instalaciones y personal capacitados para garantizar la precisión requerida en cada uno de los trabajos que se realizan. Los procesos de corte, rolado y soldadura utilizados cumplen con los códigos ASME y API.</p><p>Entre los productos que ofrecen se incluyen: Tanques de almacenamiento a presión atmosférica, recipientes de almancén sujetos a presión, tapas cónicas, abombadas y en gajos, maquila en acero al carbón y acero inoxidable.</p></div></div></section><section id=par-productos><div class=\"row container\" vertilize-container><div class=\"col s12\"><h4 class=\"italic underline\">Productos</h4><div class=\"col s12 l6 valign-wrapper\" vertilize><div class=\"image-container z-depth-1 valign\"><div id=productos-thumb></div></div></div><div class=\"col s12 l6 valign-wrapper\" vertilize><div class=\"section-container valign\"><h5 class=italic>Realizamos</h5><ul class=sangria><li><span>Tanques y Recipientes de almancenamiento sujetos a presión.</span></li><li><span>Fabricación de Tubería en dimensiones especiales.</span></li><li><span>Tapas cónicas, abombadas y en gajos.</span></li><li><span>Tapas planas con ceja y esféricas en gajos.</span></li><li><span>Rejillas para piso y desagüe tipo Irving y Punzonadas</span></li></ul></div></div></div></div></section><section id=par-servicios><div class=\"row container\" vertilize-container><div class=\"col s12\"><h4 class=\"italic underline\">Servicios</h4><div class=\"col s12 l6 valign-wrapper hide-on-large-only\"><div class=\"image-container z-depth-1 valign\"><div class=servicios-thumb></div></div></div><div class=\"col s12 l6\" vertilize><h5 class=italic>Rolado</h5><ul class=sangria><li><span>Placa de hasta 120” x 1”</span></li><li><span>Conos</span></li><li><span>Perfiles y Tubos</span></li><li><span>Tubo mecánico de hasta 12” cedula 40</span></li><li><span>PTR de hasta 8” x 8”</span></li><li><span>IPR de hasta 18” x 11” x 177.3 kg/m</span></li><li><span>Ángulo de hasta 3/4 x 6”</span></li><li><span>CPS de hasta 12” x 44.76 kg/m</span></li><li><span>Solera de Canto de hasta 3/4” x 3 1/2”</span></li></ul><h5 class=italic>Corte</h5><ul class=sangria><li><span>Corte con guillotina de placa de hasta 3/8\" y hasta 6 metros</span></li><li><span>Corte con Plasma hasta 1 1/2\" pantografo</span></li></ul><h5 class=italic>Maquinados</h5><ul class=sangria><li><span>Torno CNC</span></li><li><span>Torno convencional</span></li><li><span>Fresadoras convencionales</span></li></ul><h5 class=italic>Troquelados</h5><ul class=sangria><li><span>Troquelados de capacidad de hasta 100 toneladas</span></li></ul></div><div class=\"col s12 l6 valign-wrapper hide-on-med-and-down\" vertilize><div class=\"image-container z-depth-1 valign\"><div class=servicios-thumb></div></div></div></div></div></section><section id=par-contacto><div class=\"row container\"><div class=\"col s12\" ng-controller=\"ContactFormController as cfc\"><form novalidate><h4 class=\"italic underline\">Contacto</h4><p ng-show=cfc.success>Gracias por contactarnos</p><p ng-show=cfc.error>Algo sucedió con los datos que nos envias, intenta de nuevo</p><p>Envianos tus datos y comentarios, estaremos en contacto a la brevedad.</p><div class=\"input-field col s12 l6\"><input type=text id=nombre class=validate name=name ng-model=cfc.formData.name required><label for=nombre>Nombre:</label></div><div class=\"input-field col s12 l6\"><input type=email name=email id=email class=validate ng-model=cfc.formData.email required><label for=email>Correo:</label></div><div class=\"input-field col s12 l6\"><input type=tel name=telephone id=telephone class=validate ng-model=cfc.formData.telephone required><label for=telephone>Teléfono:</label></div><div class=\"input-field col s12\"><textarea name=comments id=comments cols=30 rows=10 class=materialize-textarea ng-model=cfc.formData.comments required></textarea><label for=comments>Mensaje:</label></div><div class=hide><input type=text id=honeypot name=honeypot class=hide ng-model=cfc.formData.honeypot><label for=honeypot></label></div><div class=\"col s12 l6\"><button name=submit value=submit class=\"btn waves-effect waves-light\" ng-click=cfc.sendMail()>Enviar <i class=\"material-icons right\">send</i></button></div></form><p ng-show=cfc.responseData.comments message=cfc.responseData.comments toast=click></p></div></div></section>");
$templateCache.put("app/components/navbar/navbar.html","<div class=navbar-fixed><nav id=header-navbar class=\"navbar navbar-default\" ng-class=\"{\'shrink\':scrollDown}\" role=navigation scroll-nav><div class=nav-wrapper><a href=#! class=brand-logo><span class=\"logo-wrapper hide-on-med-and-down\"><img src=assets/images/logoBackmann.png id=icon-vector alt=\"\"> <img src=assets/images/logoVector.png id=logo-vector> </span><img src=assets/images/logoBackmann.png id=icon-vector alt=\"\" class=\"hide-on-large-only valign\"> <img src=assets/images/logoVector.png id=logo-vector class=hide-on-large-only> </a><a href=# class=button-collapse data-activates=mobile-demo data-sidenav=left data-menuwidth=400 data-closeonclick=true><i class=material-icons>menu</i></a><ul class=\"right hide-on-med-and-down\"><li><a href=#/#par-quienes>Quienes Somos</a></li><li><a href=#/#par-productos>Productos</a></li><li><a href=#/#par-servicios ng-click=\"gotoAnchor(\'par-servicios\')\">Servicios</a></li><li><a href=#/empleos>Empleos</a></li><li><a href=#/gallery>Galería</a></li><li><a href=#/#par-contacto>Contacto</a></li></ul><div id=mobile-demo class=side-nav><div class=logo-container><img src=assets/images/logoBackmann.png class=sidenav-logo></div><ul><li><a href=#/#par-quienes>Quienes Somos</a></li><li><a href=#/#par-productos>Productos</a></li><li><a href=#/#par-servicios>Servicios</a></li><li><a href=#/empleos>Empleos</a></li><li><a href=#/gallery>Galería</a></li><li><a href=#/#par-contacto>Contacto</a></li></ul></div></div></nav></div>");}]);